const selectOnFocus = (event) => event.target.select();

export default selectOnFocus;
